import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App';
import GalleryApp from './components/GalleryApp';
import { createFontLoader } from './utils/Fontloader';

import '../src/index.css';

const fontloader = createFontLoader({
    'Open Sans': {},
});

const getParams = query => {
    if (!query) {
        return {};
    }

    return (/^[?#]/.test(query) ? query.slice(1) : query)
        .split('&')
        .reduce((params, param) => {
            let [key, value] = param.split('=');
            params[key] = value
                ? decodeURIComponent(value.replace(/\+/g, ' '))
                : '';
            return params;
        }, {});
};

fontloader
    .loadAll()
    .then(data => (document.documentElement.className += ' fl'))
    .catch(e => console.warn('Fonts could not be loaded', e));

const $mount = document.getElementById('root');
const mountPreviews = [...document.querySelectorAll('[data-preview-key]')];
const $galleryAppMountpoint = document.querySelector('[data-app="gallery"]');

if ($mount) {
    const params = getParams(window.location.search);
    const pathToConfig = $mount.getAttribute('data-config');
    const variationId = params.key;

    if (pathToConfig) {
        ReactDOM.render(
            <App pathToConfig={pathToConfig} variationId={variationId} />,
            $mount
        );
    } else {
        console.warn(`No data-config attribute on mount point.`);
    }
}

if (mountPreviews.length > 0) {
    mountPreviews.forEach($mountPreview => {
        const pathToConfig = $mountPreview.getAttribute('data-config');
        const key = $mountPreview.getAttribute('data-preview-key');

        if (pathToConfig) {
            ReactDOM.render(
                <App pathToConfig={pathToConfig} previewForKey={key} />,
                $mountPreview
            );
        } else {
            console.warn(`No data-config attribute on mount point.`);
        }
    });
}

if ($galleryAppMountpoint) {
    if (window.__galleryState) {
        ReactDOM.render(
            <GalleryApp items={window.__galleryState} />,
            $galleryAppMountpoint
        );
    }
}



// WEBPACK FOOTER //
// ./src/index.js